import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import Block from './Block';

/**
 * Renders an `insight_callout` block from ActionableInsightsResult.summary
 * (markdown). Used when the agent calls generate_insights.
 */
const InsightCallout = ({ blockData = {} }) => {
  const summary = blockData.summary || '';
  return (
    <Block icon="lightbulb" title="Actionable insights">
      <div className="q-md" style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--fg)' }}>
        <ReactMarkdown remarkPlugins={[remarkBreaks]}>{summary}</ReactMarkdown>
      </div>
    </Block>
  );
};

export default InsightCallout;
